import { IDirective, IDirectiveFactory, IScope } from "angular";
import { IPlugin } from "@gtmhub/plugins";

export interface PluginOnLoadScope extends IScope {
  plugin: IPlugin;
}

export class PluginOnLoad implements IDirective {
  public scope = {
    plugin: "=",
  };

  public link(scope: PluginOnLoadScope, element: JQuery<HTMLIFrameElement>): void {
    element.on("load", () => {
      element.attr("sandbox", scope.plugin.uiPlugin.featurePolicy);
    });
  }

  public static factory(): IDirectiveFactory {
    const directive = () => new PluginOnLoad();
    directive.$inject = [];
    return directive;
  }
}
